import { useState, useRef, useEffect, useContext } from "react";
import FilterContext from "../../Hooks/Context";
import { useTranslation } from "react-i18next";

import "./dropdown.css";

const Dropdown = (props) => {
  const [isOpen, setOpen] = useState(false);
  const [items, setItem] = useState(props.data);
  const [name, SetName] = useState(props.name);
  const [noReload, SetReload] = useState(props.noReload);
  const [selectedItem, setSelectedItem] = useState();
  const [dropdownLabel, SetDropdownLabel] = useState();
  const wrapperRef = useRef(null);

  const { t } = useTranslation();

  const filterQueries = useContext(FilterContext);

  const toggleDropdown = () => setOpen(!isOpen);

  const handleItemClick = (id, name, noReload) => {
    selectedItem === id ? setSelectedItem(null) : setSelectedItem(id);
    setOpen(false);
    props.onChange && props.onChange(id);
    SetDropdownLabel(items[id - 1].label);
    let shiftDetails = {
      1: "A",
      2: "B",
      3: "C",
    };
    if (noReload) {
      props.SetFilterValue(id, name)
      return
    }
    let updatedFilterQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
    if (name === "shift") {
      updatedFilterQuery[name] = shiftDetails[id - 1];
    }
    filterQueries.GenerateFilters(updatedFilterQuery);
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  useEffect(() => {
    props.selectedItem && SetDropdownLabel(props.selectedItem.label);
  }, []);

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  return (
    <div className="dropdown" ref={wrapperRef}>
      <div className="dropdown-header" onClick={toggleDropdown}>
        {t(dropdownLabel)}
        <i className={`fa fa-chevron-right icon ${isOpen && "open"}`}></i>
      </div>
      <div className={`dropdown-body ${isOpen && "open"}`}>
        {items &&
          items.map((item) => (
            <div
              className="dropdown-item"
              key={item.id}
              onClick={(e) => handleItemClick(e.target.id, name, noReload)}
              id={item.id}
            >
              <span
                className={`dropdown-item-dot ${
                  item.id === selectedItem && "selected"
                }`}
              >
                •{" "}
              </span>
              { t(item.label) }
            </div>
          ))}
      </div>
    </div>
  );
};

export default Dropdown;
